import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import {
  HeaderMarginTop as Main,
  BlueTopBar,
  BlueTopBarTitle,
  MainWrapper,
  Center,
  Div,
} from 'legacyComponents/styled/lib';
import { Button } from 'components';
import { FormWrapper } from 'libs/forms/styles';
import { BackButton } from 'legacyComponents/buttons/backButton';
import { clientStore } from 'apps/client/app';
import { media } from 'legacyComponents/styled/styleUtils';

import { goBack } from 'core/routing';

import { Trans, withNamespaces } from 'react-i18next';

@withNamespaces()
@observer
export class FormPage extends React.Component {
  componentDidMount() {
    clientStore.ScrollToTop();
  }

  render() {
    const {
      title,
      formTitle,
      children,
      buttonText,
      buttonHandler,
      noBackButton,
    } = this.props;
    // const {posting} = app;
    return (
      <Main>
        <BlueTopBar>
          <MainWrapper subPage>
            <BlueTopBarTitle>
              <Trans>{title}</Trans>
            </BlueTopBarTitle>
            {noBackButton ? '' : <BackButton onclick={goBack} />}
          </MainWrapper>
        </BlueTopBar>
        <Wrapper>
          <div>
            {formTitle ? (
              <div>
                <Title>
                  <Trans>{formTitle}</Trans>
                </Title>
              </div>
            ) : (
              ''
            )}
            <ChildrenWrapper>{children}</ChildrenWrapper>
            {buttonText && buttonHandler ? (
              <Center>
                <ButtonStyled
                  text={<Trans>{buttonText}</Trans>}
                  onClick={buttonHandler}
                />
              </Center>
            ) : (
              <Div height='20px' />
            )}
          </div>
        </Wrapper>
      </Main>
    );
  }
}

FormPage.propTypes = {
  title: PropTypes.string,
  formTitle: PropTypes.string,
  children: PropTypes.node,
  buttonText: PropTypes.string,
  buttonHandler: PropTypes.func,
  noBackButton: PropTypes.bool,
  t: PropTypes.func,
};

const Wrapper = styled.div`
  display: block;
  height: auto;
  width: 680px;
  margin: -45px auto 60px auto;
  padding-bottom: 0;
  background-color: ${props => props.theme.color.wfWhite};
  position: relative;
  z-index: 2;
  opacity: ${props => (props.posting ? '0.4' : '1')};
  transition: opacity 300ms ease-in-out;
  cursor: ${props =>
    props.posting ? 'progress !important' : 'inherit !important'};
  ${media.s`
    width: calc(100% - 40px);
  `}
`;

const Title = styled.h1`
  font-size: 0.9375em;
  margin: ${props => (props.centered ? '0' : '0 0 0 25px')};
  padding: 15px 15px 12px;
  color: ${props => props.theme.color.primary};
  text-align: ${props => (props.centered ? 'center' : 'inherit')};
`;

const ChildrenWrapper = styled(FormWrapper)`
  padding: 0;
  ${media.s`
    width: calc(100% - 80px);
  `}
  ${media.xs`
    width: calc(100% - 40px);
  `}
`;

const ButtonStyled = styled(Button)`
  margin: ${props => `${props.theme.spacing.default} 0`};
`;
